import Swiper from 'swiper';

export default function initTabs() {
    const tabSections = document.querySelectorAll('.block-slider');

    tabSections.forEach(section => {
        new Tabs(section as HTMLElement);
    });
}

class Tabs {
    $el: HTMLElement;
    tabItems: HTMLElement[];
    tabPanes: HTMLElement[];
    swiper?: Swiper;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.tabItems = Array.from(this.$el.querySelectorAll('.tab-item'));
        this.tabPanes = Array.from(this.$el.querySelectorAll('.tab-pane'));

        if (!this.tabItems.length || !this.tabPanes.length) return;

        this.init();
        this.initSwiperIfOverflow();
    }

    init(): void {
        this.tabItems[0].classList.add('active');
        this.tabPanes[0].classList.add('active');

        this.tabItems.forEach(item => {
            item.addEventListener('click', () => {
                const tabId = item.getAttribute('data-tab');
                if (!tabId) return;

                this.tabItems.forEach(i => i.classList.remove('active'));
                this.tabPanes.forEach(p => p.classList.remove('active'));

                item.classList.add('active');

                const targetPane = this.$el.querySelector(`#${tabId}`);
                if (targetPane instanceof HTMLElement) {
                    targetPane.classList.add('active');
                }
            });
        });
    }

    initSwiperIfOverflow(): void {
        const container = this.$el.querySelector('.swiper-tab-nav') as HTMLElement;
        const wrapper = container?.querySelector('.swiper-wrapper') as HTMLElement;

        if (!container || !wrapper) return;

        const totalWidth = Array.from(wrapper.children).reduce((sum, child) => {
            return sum + (child as HTMLElement).offsetWidth;
        }, 0);

        if (totalWidth > container.offsetWidth) {
            this.swiper = new Swiper(container, {
                slidesPerView: 'auto',
                grabCursor: true,
                spaceBetween: 0,
            });
        }
    }
}
